import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fireErrorAnalytics } from '../../../../common/utils.tsx';
import type { ProjectProperties, RequestParams, Response } from './types.tsx';

export const performGetProjectPropertiesRequest = async ({
	projectId,
}: RequestParams): Promise<ProjectProperties | null> => {
	try {
		// Note: Could NOT use getUserProperties from other packages
		// because of bug where that function performs JSON.Parse on all response data, but the BE
		// data we are fetching here is not stored in a JSON format.
		const params = new URLSearchParams();
		params.append('projectId', projectId);
		params.append('project', 'initial.project.template.name');

		const { project }: Response = await performGetRequest(
			`/rest/internal/latest/frontendconfig/properties?${params.toString()}`,
		);

		return project;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		if (error?.statusCode === 404) {
			return null;
		}

		fireErrorAnalytics(
			{
				subject: 'getIsCustomerTemplateProject',
			},
			error,
		);
		return null;
	}
};
